import { Link } from 'react-router-dom';
import { useCategoryBreadcrumbs } from '../../../lib/api/hooks';

type BreadcrumbsProps = {
  categoryId?: string;
  categorySlug?: string;
  homeLabel?: string;
};

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ categoryId, homeLabel = 'Inicio' }) => {
  // Solo hacer la llamada si tenemos un categoryId válido (no un slug)
  const shouldFetch = !!categoryId && categoryId.length > 0 && !categoryId.includes('-');
  const { data: crumbs, loading, error } = useCategoryBreadcrumbs(shouldFetch ? (categoryId || '') : '');

  // Asegurar que crumbs es un array
  const safeCrumbs = Array.isArray(crumbs) ? crumbs : [];

  // Si no debemos hacer fetch (porque solo tenemos slug), no mostrar breadcrumbs por ahora
  if (!shouldFetch) {
    return null;
  }

  return (
    <nav className="text-sm text-gray-600" aria-label="Breadcrumb">
      <ol className="flex items-center gap-2">
        <li>
          <Link to="/" className="hover:text-black">{homeLabel}</Link>
        </li>
        {safeCrumbs.length > 0 && <li className="text-gray-400">/</li>}
        {loading ? (
          <li className="text-gray-400">Cargando…</li>
        ) : error || safeCrumbs.length === 0 ? null : (
          safeCrumbs.map((c, idx, arr) => (
            <li key={c.id} className="flex items-center gap-2">
              <Link to={`/products?category=${c.slug}`} className={idx === arr.length - 1 ? 'text-black font-medium' : 'hover:text-black'}>
                {c.name}
              </Link>
              {idx < arr.length - 1 && <span className="text-gray-400">/</span>}
            </li>
          ))
        )}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;







